export function domReady(func: (event?: Event) => void): void {
  if (document?.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", func, { once: true });
  } else {
    func();
  }
}
